export const metadata = () => {
  let token = localStorage.getItem('trade.token') || window.electron?.store.get('trade.token');
  let server =
    localStorage.getItem('trade.server') || window.electron?.store.get('trade.server') || 'live2';

  const headers = { Authorization: 'Bearer ' + token };

  // In development, add custom header for proxy routing
  if (process.env.NODE_ENV === 'development') {
    headers['X-Trade-Server'] = server;
  }

  return headers;
};
